import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FestiveBanner() {
  return (
    <section data-testid="festive-banner" className="bg-ink-deep border-b border-gold/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center">
        <p className="font-serif italic text-cream/90 text-sm sm:text-base">
          The Festive Edit is here — Diwali hampers now booking for 2026
        </p>
        <Link
          to="/festive"
          data-testid="festive-banner-link"
          className="inline-flex items-center gap-1.5 text-sm text-gold font-medium gold-underline-btn"
        >
          Explore the lookbook <ArrowUpRight size={14} />
        </Link>
      </div>
    </section>
  );
}
